<template>
    <div class="container-fluid mt-5 py-5">
        <div class="text-center">
            <div class="error mx-auto" data-text="404">404</div>
            <p class="lead text-gray-800 mb-5">{{$t('PAGE_NOT_FOUND')}}</p>
            <p class="text-gray-500 mb-0">{{$t('PAGE_NOT_FOUND_MESSAGE')}}</p>
            <router-link to="/">&larr; {{$t('BACK_TO_INDEX')}}</router-link>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>

<style>
</style>
